import { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

import { OnboardPostJoinWizard } from "../../components/features/onboard-post-join/onboard-post-join-wizard.tsx";
import { SqeOnboardingLinkContext } from "../../components/features/onboarding/sqe/sqe-onboarding-link-context.tsx";
import { useSqeLabs } from "../../hooks/use-sqe-labs.ts";

import styles from "./onboard-post-join-page.module.css";

const HERO_CARD_BG = "/assets/images/onboarding-form-card-bg.png";

export default function OnboardPostJoinPage() {
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();
  const isSqeLink = pathname === "/onboard-post-join/sqe";
  const isSqePortal = useSqeLabs();
  const isSqe = isSqeLink || isSqePortal;
  const token = searchParams.get("token");
  const [verifiedEmployeeName, setVerifiedEmployeeName] = useState<string | null>(null);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    setVerifiedEmployeeName(null);
  }, [token]);

  const welcomeTitle = isSqe
    ? "Welcome to SQE Labs"
    : verifiedEmployeeName?.trim()
      ? `Welcome, ${verifiedEmployeeName.trim()}`
      : "Welcome";

  return (
    <SqeOnboardingLinkContext.Provider value={isSqeLink}>
      <div className={styles.page} data-theme="caelius-classic">
      <header className={styles.topBar}>
        <img
          className={`${styles.logo} ${isSqe ? styles.sqeLogo : ""}`.trim()}
          src={isSqe ? "/assets/sqe-login/sqe_logo.svg" : "/assets/CaeliusOne_logo.svg"}
          alt={isSqe ? "SQE Labs" : "Caelius Consulting Logo"}
          width={isSqe ? 110 : 150}
        />
      </header>
      <main className={styles.main}>
        <div className={styles.inner}>
          {!submitted && token ? (
            <section
              className={styles.heroCard}
              style={{ backgroundImage: `url(${HERO_CARD_BG})` }}
              aria-labelledby="onboard-post-join-page-title"
            >
              <h1 id="onboard-post-join-page-title" className={styles.heroTitle}>
                {welcomeTitle}
              </h1>
              <div className={styles.heroLine} aria-hidden />
              <p className={`body-sm ${styles.heroIntro}`}>
                You’re almost there! Complete your onboarding by sharing your bank details and required employment documents.
              </p>
            </section>
          ) : null}
          {!token ? (
            <p className={`body-sm ${styles.error}`} role="alert">
              This page must be opened using the link from your onboarding email (it should include a
              token in the URL).
            </p>
          ) : (
            <OnboardPostJoinWizard
              token={token}
              onEmployeeVerified={(name) => {
                const trimmed = name.trim();
                setVerifiedEmployeeName(trimmed.length > 0 ? trimmed : null);
              }}
              onSubmitted={() => setSubmitted(true)}
            />
          )}
        </div>
      </main>
      </div>
    </SqeOnboardingLinkContext.Provider>
  );
}
